import { useEffect } from "react";

/**
 * Warn the user via the browser's native beforeunload dialog when they try to
 * close/refresh the tab with unsaved changes. No-op when `isDirty` is false.
 */
export function useUnsavedChanges(isDirty: boolean): void {
  useEffect(() => {
    if (!isDirty) return;
    const onBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [isDirty]);
}
